import ChargePointDetails from '@/components/ChargePointDetails';
import ConnectorDetails from '@/components/ConnectorDetails';
import { Button } from '@/shared/components/ui/button';
import { Drawer, DrawerClose, DrawerContent, DrawerHeader } from '@/shared/components/ui/drawer';
import { type ChargePoint, type Connector } from '@/types/swagger';
import { X } from 'lucide-react';

interface ChargeCenterDrawerProps {
  onClose: () => void;
  selectedConnector: Connector | null;
  selectedChargePoint: ChargePoint | null;
  selectedChargePointConnectors: Connector[];
}

const ChargeCenterDrawer = ({
  onClose,
  selectedConnector,
  selectedChargePoint,
  selectedChargePointConnectors,
}: ChargeCenterDrawerProps) => {
  const isSelectedConnector = !!selectedConnector;
  const isSelectedChargePoint = !!selectedChargePoint;
  const isOpen = isSelectedConnector || isSelectedChargePoint;
  return (
    <Drawer direction="right" open={isOpen} onClose={onClose}>
      <DrawerContent id="charge-center-drawer">
        <DrawerHeader className="$tw-justify-end">
          <DrawerClose>
            <Button size="icon" variant="ghost" aria-label="Close drawer">
              <X aria-hidden={true} />
            </Button>
          </DrawerClose>
        </DrawerHeader>
        {isSelectedConnector ? <ConnectorDetails /> : null}
        {isSelectedChargePoint ? (
          <ChargePointDetails
            chargePoint={selectedChargePoint}
            chargePointConnectors={selectedChargePointConnectors}
          />
        ) : null}
      </DrawerContent>
    </Drawer>
  );
};

export default ChargeCenterDrawer;
